import { getPostCode } from '@/helpers/getPostcode'

export default {
  getPlaces: (state) => () => state.places,
  getPlaceIdByIndex: (state) => (idx) => state.places[idx].place_id,
  getPostCode: (state) => getPostCode(state.place.address_components),
  getCountryMany: (state) => state.countryMany,
  getCountryOne: (state) => state.countryOne,
}
